import moment from "moment"

export const taskStatusOptions = [
    { id: 1, value: "Atrasado" },
    { id: 2, value: "Em breve" },
    { id: 3, value: "Concluído" },
    { id: 4, value: "Cancelado" },
]

export const initialTaskFilters = () => ({
    status: [1, 2],
    dateStart: moment().subtract(7, "d").format("YYYY-MM-DD"),
    dateEnd: moment().subtract(1, "d").format("YYYY-MM-DD"),
})
